const routeModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/runs/route-modal/route-modal.html',
  controller: 'RouteModalController',
};

angular
  .module('pis-tool.module')
  .component('routeModal', routeModal);
